// Products grouped by capability category.
// Images live in /public/assets/products/<Folder Name>/<file>.png
// Folder names mirror the client-provided category folders.

const base = "/assets/products";

const img = (folder, file) => encodeURI(`${base}/${folder}/${file}`);

export const PRODUCT_CATEGORIES = [
  {
    id: "shipbuilding-ship-repair",
    name: "Shipbuilding & Ship Repair",
    description: "Full-service construction and specialized maintenance solutions for the global maritime fleet.",
    products: [
      { name: "Bollards", image: img("Shipbuilding and repair", "Bollards.png") },
      { name: "Bulkhead Panels", image: img("Shipbuilding and repair", "Bulkhead_Panels.png") },
      { name: "Chain Stoppers", image: img("Shipbuilding and repair", "Chain_Stoppers.png") },
      { name: "Engine and Gearbox Seatings", image: img("Shipbuilding and repair", "Engine_and_Gearbox_Seatings.png") },
      { name: "Equipment Foundations", image: img("Shipbuilding and repair", "Equipment_Foundations.png") },
      { name: "Fairleads", image: img("Shipbuilding and repair", "Fairleads.png") },
      { name: "Hatch Coamings", image: img("Shipbuilding and repair", "Hatch_Coamings.png") },
      { name: "Hatch Covers", image: img("Shipbuilding and repair", "Hatch_Covers.png") },
      { name: "Pipe Spools", image: img("Shipbuilding and repair", "Pipe_Spools.png") },
      { name: "Sea Chest Gratings", image: img("Shipbuilding and repair", "Sea_Chest_Gratings.png") },
      { name: "Sea Chests", image: img("Shipbuilding and repair", "Sea_Chests.png") },
      { name: "Watertight Doors", image: img("Shipbuilding and repair", "Watertight_Doors.png") },
    ],
  },
  {
    id: "deck-machinery-marine-equipment",
    name: "Deck Machinery & Marine Equipment",
    description: "Robust, heavy-duty deck systems engineered for reliability in demanding offshore operations.",
    products: [
      { name: "A-Frames", image: img("Marine and deck equipment", "A-Frames.png") },
      { name: "Bearing Housings", image: img("Marine and deck equipment", "Bearing_Housings.png") },
      { name: "Crane Pedestals", image: img("Marine and deck equipment", "Crane_Pedestals.png") },
      { name: "Davit Arms", image: img("Marine and deck equipment", "Davit_Arms.png") },
      { name: "Grooved Winch Drums", image: img("Marine and deck equipment", "Grooved_Winch_Drums.png") },
      { name: "Hydraulic Manifold Blocks", image: img("Marine and deck equipment", "Hydraulic_Manifold_Blocks.png") },
      { name: "King Posts", image: img("Marine and deck equipment", "King_Posts.png") },
      { name: "Rope Drums", image: img("Marine and deck equipment", "Rope_Drums.png") },
      { name: "Sheave Blocks", image: img("Marine and deck equipment", "Sheave_Blocks.png") },
      { name: "Stern Rollers", image: img("Marine and deck equipment", "Stern_Rollers.png") },
      { name: "Winch Base Frames", image: img("Marine and deck equipment", "Winch_Base_Frames.png") },
      { name: "Winch Drums", image: img("Marine and deck equipment", "Winch_Drums.png") },
    ],
  },
  {
    id: "steering-propulsion-manoeuvring",
    name: "Steering, Propulsion & Manoeuvring",
    description: "High-precision steering gear and propulsion components for superior vessel control and efficiency.",
    products: [
      { name: "Fin Stabiliser Cartridges", image: img("Steering, Propulsion & Manoeuvring", "Fin_Stabiliser_Cartridges.png") },
      { name: "Flange Couplings", image: img("Steering, Propulsion & Manoeuvring", "Flange_Couplings.png") },
      { name: "Gearbox Housings", image: img("Steering, Propulsion & Manoeuvring", "Gearbox_Housings.png") },
      { name: "Kort Nozzles", image: img("Steering, Propulsion & Manoeuvring", "Kort_Nozzles.png") },
      { name: "Rudder Assemblies", image: img("Steering, Propulsion & Manoeuvring", "Rudder_Assemblies.png") },
      { name: "Rudder Blades", image: img("Steering, Propulsion & Manoeuvring", "Rudder_Blades.png") },
      { name: "Rudder Stocks", image: img("Steering, Propulsion & Manoeuvring", "Rudder_Stocks.png") },
      { name: "Rudder Trunks", image: img("Steering, Propulsion & Manoeuvring", "Rudder_Trunks.png") },
      { name: "Shaft Brackets", image: img("Steering, Propulsion & Manoeuvring", "Shaft_Brackets.png") },
      { name: "Stern Tube Bushes", image: img("Steering, Propulsion & Manoeuvring", "Stern_Tube_Bushes.png") },
      { name: "Stern Tubes", image: img("Steering, Propulsion & Manoeuvring", "Stern_Tubes.png") },
      { name: "Thruster Tunnels", image: img("Steering, Propulsion & Manoeuvring", "Thruster_Tunnels.png") },
    ],
  },
  {
    id: "dredging",
    name: "Dredging",
    description: "Specialized equipment and structural components built for heavy-duty harbor and channel maintenance.",
    products: [
      { name: "Ball Joints", image: img("Dredging", "Ball_Joints.png") },
      { name: "Discharge Pipe Sections", image: img("Dredging", "Discharge_Pipe_Sections.png") },
      { name: "Expansion Pieces", image: img("Dredging", "Expansion_Pieces.png") },
      { name: "Flanged Pipe Sections", image: img("Dredging", "Flanged_Pipe_Sections.png") },
      { name: "Pipe Bends", image: img("Dredging", "Pipe_Bends.png") },
      { name: "Pipe Elbows", image: img("Dredging", "Pipe_Elbows.png") },
      { name: "Pipe Liners", image: img("Dredging", "Pipe_Liners.png") },
      { name: "Suction Pipe Sections", image: img("Dredging", "Suction_Pipe_Sections.png") },
      { name: "Swivel Joints", image: img("Dredging", "Swivel_Joints.png") },
      { name: "Wear Plates", image: img("Dredging", "Wear_Plates.png") },
      { name: "Winch Drums", image: img("Dredging", "Winch_Drums.png") },
      { name: "Winch Frames", image: img("Dredging", "Winch_Frames.png") },
    ],
  },
  {
    id: "steel-plant-equipment",
    name: "Steel Plant Equipment",
    description: "Durable, high-heat resistant machinery and structural parts for large-scale metallurgical operations.",
    products: [
      { name: "Bridle Rolls", image: img("Steel plant equipment", "Bridle_Rolls.png") },
      { name: "Coiler Mandrels", image: img("Steel plant equipment", "Coiler_Mandrels.png") },
      { name: "Continuous Casting Moulds", image: img("Steel plant equipment", "Continuous_Casting_Moulds.png") },
      { name: "Deflector Roll Arms", image: img("Steel plant equipment", "Deflector_Roll_Arms.png") },
      { name: "Foot Rolls", image: img("Steel plant equipment", "Foot_Rolls.png") },
      { name: "Leveller Cassettes", image: img("Steel plant equipment", "Leveller_Cassettes.png") },
      { name: "Pay-Off Reel Assemblies", image: img("Steel plant equipment", "Pay-Off_Reel_Assemblies.png") },
      { name: "Pinch Rolls", image: img("Steel plant equipment", "Pinch_Rolls.png") },
      { name: "Roll Chocks", image: img("Steel plant equipment", "Roll_Chocks.png") },
      { name: "Roll Sleeves", image: img("Steel plant equipment", "Roll_Sleeves.png") },
      { name: "Table Rollers", image: img("Steel plant equipment", "Table_Rollers.png") },
      { name: "Wrapper Rolls", image: img("Steel plant equipment", "Wrapper_Rolls.png") },
    ],
  },
  {
    id: "power-process-equipment",
    name: "Power & Process Equipment",
    description: "Critical infrastructure components designed for peak efficiency in power generation and chemical processing.",
    products: [
      { name: "Boiler Support Structures", image: img("Power and process equipment", "Boiler_Support_Structures.png") },
      { name: "Buckstays", image: img("Power and process equipment", "Buckstays.png") },
      { name: "Dampers", image: img("Power and process equipment", "Dampers.png") },
      { name: "Ducting Sections", image: img("Power and process equipment", "Ducting_Sections.png") },
      { name: "Expansion Joints", image: img("Power and process equipment", "Expansion_Joints.png") },
      { name: "Guillotine Gates", image: img("Power and process equipment", "Guillotine_Gates.png") },
      { name: "Heat Exchanger Shells", image: img("Power and process equipment", "Heat_Exchanger_Shells.png") },
      { name: "Hoppers", image: img("Power and process equipment", "Hoppers.png") },
      { name: "Hub-Skirt Assemblies", image: img("Power and process equipment", "Hub-Skirt_Assemblies.png") },
      { name: "Pipe Support Structures", image: img("Power and process equipment", "Pipe_Support_Structures.png") },
      { name: "Transfer Chutes", image: img("Power and process equipment", "Transfer_Chutes.png") },
      { name: "Tube Sheets", image: img("Power and process equipment", "Tube_Sheets.png") },
    ],
  },
  {
    id: "defence-systems",
    name: "Defence Systems",
    description: "Mission-ready precision manufacturing and assembly for advanced military and defense applications.",
    products: [
      { name: "Armoured Hatch Door", image: img("Defence equipments", "Armoured_Hatch_Door.png") },
      { name: "Gun Base Frame", image: img("Defence equipments", "Gun_Base_Frame.png") },
      { name: "Gun Cradle", image: img("Defence equipments", "Gun_Cradle.png") },
      { name: "Hydroplane", image: img("Defence equipments", "Hydroplane.png") },
      { name: "Launcher Base Frame", image: img("Defence equipments", "Launcher_Base_Frame.png") },
      { name: "Missile Launcher Cradle", image: img("Defence equipments", "Missile_Launcher_Cradle.png") },
      { name: "Sonar Dome", image: img("Defence equipments", "Sonar_Dome.png") },
      { name: "Submarine Rudder Assembly", image: img("Defence equipments", "Submarine_Rudder_Assembly.png") },
      { name: "Tank Hatch Door", image: img("Defence equipments", "Tank_Hatch_Door.png") },
      { name: "Truck-Mounted Gun Structure", image: img("Defence equipments", "Truck-Mounted_Gun_Structure.png") },
      { name: "Turret Ring Structure", image: img("Defence equipments", "Turret_Ring_Structure.png") },
      { name: "Weapon Foundation", image: img("Defence equipments", "Weapon_Foundation.png") },
    ],
  },
];
